import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import type { Values } from '@swf/core/types/i18n';

import type { PreCashinInfo } from '../../../../../../../../../types/Cashier';
import { Messages, getBonusMessage } from '../../../../../../../../../utils/bonus';
import TicketSetRecord from '../../../../../TicketSetRecord/TicketSetRecord';

import { TXTCLI_Each_ticket_set_consists_of_th_ELL } from './TicketPortion.messages.json';

interface Props {
  isFirst: boolean;
  amount: number;
  bonusFormatted: JSX.Element | number;
  formattedAmount: JSX.Element;
  isSingleTicketInSet: boolean;
}

const getValues = (
  isAmountOne: boolean,
  isSingleTicket: boolean,
  bonus: JSX.Element | number,
  ticketName: string,
  formattedAmount: JSX.Element | number,
  isFirst: boolean
): Values => {
  if (isFirst) {
    if (isAmountOne) {
      return { 0: formattedAmount };
    }

    return { 0: formattedAmount, 1: bonus };
  }

  if (isSingleTicket) {
    if (isAmountOne) {
      return { 0: formattedAmount, 1: ticketName };
    }

    return { 0: formattedAmount, 1: bonus, 2: ticketName };
  }

  return { 0: formattedAmount, 1: bonus };
};

const TicketPortion: React.FC<Props> = ({
  isFirst,
  amount,
  bonusFormatted,
  isSingleTicketInSet,
  formattedAmount
}) => {
  const {
    data: { preCashinInfo }
  } = useWizardContext();

  const { fppReleasePortion, ticketReleasePortion, bonusTicketName, ticketSet } =
    preCashinInfo as PreCashinInfo;
  const isAmountOne = amount === 1;

  return (
    <>
      <Translation
        tagName="p"
        {...getBonusMessage(
          isFirst ? Messages.TicketsFirst : Messages.TicketsYour,
          isSingleTicketInSet,
          isAmountOne
        )}
        values={{
          ...getValues(
            isAmountOne,
            isSingleTicketInSet,
            bonusFormatted,
            bonusTicketName,
            formattedAmount,
            isFirst
          )
        }}
      />
      {!isSingleTicketInSet && (
        <>
          <Translation tagName="p" {...TXTCLI_Each_ticket_set_consists_of_th_ELL} />
          <TicketSetRecord ticketSet={ticketSet} />
        </>
      )}
      <Translation
        tagName="p"
        {...getBonusMessage(
          Messages.TicketsCollect,
          isSingleTicketInSet,
          ticketReleasePortion === 1
        )}
        values={{
          0: fppReleasePortion,
          1: ticketReleasePortion
        }}
      />
    </>
  );
};

export default TicketPortion;
